<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <page>
    <template v-slot:content>
      <transition name="slidedown">
        <div v-if="crumbsVisible" class="page-crumbs">
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <router-link
                :key="`crumb_${crumb.name}`"
                v-for="crumb in $route.meta.crumbs"
                :to="{ name: crumb.name }"
                tag="li"
              >
                <a
                  ><span class="link">{{ crumb.label }}</span></a
                >
              </router-link>
              <li v-if="article" class="is-active">
                <a href="#" aria-current="page">{{ article.title }}</a>
              </li>
            </ul>
          </nav>
        </div>
      </transition>
      <div class="page">
        <section class="page-section" v-if="!article">
          Loading...
        </section>
        <section class="page-section" v-if="article">
          <div class="section-heading">
            <div class="title is-size-2 is-bold">
              {{ getTitleByLanguage() }}
            </div>
            <div class="crimson">
              <span style="font-weight: bold;margin-right: .5rem;">{{
                getAuthorByLanguage()
              }}</span>
              <span style="font-weight: normal; margin-right: .5rem;">{{
                $t("published")
              }}</span>
              <i :title="getPublishedByLanguage()">{{
                timeAgo(getPublishedByLanguage())
              }}</i>
            </div>
          </div>
          <div class="page-section-content" v-if="getImageUrlByLanguage()">
            <div style="width: 100%; display: flex; justify-content: center;">
              <img :src="getImageUrlByLanguage()" class="title-image" />
            </div>
          </div>
          <div
            class="page-section-content crimson article-content"
            style="font-size: 1.5rem;"
          >
            <p
              style="margin: 0 .75rem 0 .75rem;"
              v-html="getContentByLanguage()"
            ></p>
          </div>
        </section>
      </div>
    </template>
  </page>
</template>

<script>
import Page from "./../common/page";
import Article from "./../../services/article";
import { format, register } from "timeago.js";
import csLocale from "timeago.js/lib/lang/cs";
import { mapGetters } from "vuex";
import urlJoin from "proper-url-join";

register("cs", csLocale);

export default {
  computed: {
    ...mapGetters({ locale: "language/locale" }),
    translation() {
      if (!this.article) {
        return null;
      }
      let translation = this.article.ArticleTranslations[0];
      for (let t in this.article.ArticleTranslations) {
        if (t.Language && t.Language.two_letter_code === this.locale) {
          translation = t;
          break;
        }
      }
      return translation;
    }
  },
  data() {
    return {
      article: null,
      prevRoute: null,
      crumbsVisible: false
    };
  },
  methods: {
    timeAgo(date) {
      return format(date, this.locale);
    },
    getTitleByLanguage() {
      return this.translation && this.translation.title;
    },
    getAuthorByLanguage() {
      return (
        this.translation && this.translation.Authors.map(a => a.name).join(", ")
      );
    },
    getPublishedByLanguage() {
      return this.translation && this.translation.published_at;
    },
    getImageUrlByLanguage() {
      if (this.translation && this.translation.preview_image_id) {
        return urlJoin(
          process.env.VUE_APP_IMAGES_URL,
          this.translation.preview_image_id,
          "max-width/640"
        );
      }
      return null;
    },
    getContentByLanguage() {
      return this.translation && this.translation.content;
    }
  },
  components: {
    Page
  },
  metaInfo: {
    title: "Article"
  },
  async mounted() {
    this.article = await Article.get(this.$route.params.idOrName);
    this.crumbsVisible = true;
  }
};
</script>
<style lang="scss">
@import "article";
</style>
<style lang="scss" scoped>
@import "./../../styles/index";
@import "./page-scoped";

.link {
  color: $color-text;
  cursor: pointer;

  &:hover {
    @include link-underline(#e1e1e1, $color-text, $color-selection);
  }
}

.title-image {
  max-width: 640px;
  max-height: 640px;
  object-fit: contain;
}

.bottom-links {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
</style>
